import { render } from "./EnvironmentBadge.vue?vue&type=template&id=6a2c26dd&scoped=true"
import script from "./EnvironmentBadge.vue?vue&type=script&lang=js"
export * from "./EnvironmentBadge.vue?vue&type=script&lang=js"

import "./EnvironmentBadge.vue?vue&type=style&index=0&id=6a2c26dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a2c26dd"]])

export default __exports__